import { ApiResponse } from '../pages/Murabaha/services/murabaha.type';

const _handleApiCall = (apiCall: () => Promise<any>) => {
  return new Promise<ApiResponse<any>>(async (resolve) => {
    try {
      const res = await apiCall();
      resolve({
        isSuccess: res.status === 200 || res.status === 201,
        data: res.data,
        message: res.data.message,
        statusCode: res.status,
      });
    } catch (error) {
      let message = 'An error occurred';
      if (error.response && error.response.data) {
        const errors = error.response.data;
        let messages: string[] = [];
        Object.keys(errors).forEach((key) => {
          const msgs: string[] = errors[key];
          messages = messages.concat(msgs);
        });
        message = messages.join(' ');
      }
      resolve({ isSuccess: false, message });
    }
  });
};

export default _handleApiCall;
